import { differenceInHours, differenceInMinutes, format } from "date-fns";
import { NextYearsDDL } from "../constants/constant";
import { AllMonths } from "../data/dropDownData";

export function getUserTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
export function convertLocalToUTC(localDateTime: any) {
    if (!localDateTime) return null;

    return new Date(localDateTime).toISOString();
}
export function convertUTCToLocal(utcDateTime: any) {
    return new Date(utcDateTime);
}
export function formatDateyyyyMMdd(inputDate: any, delimiter?: String) {
    inputDate = new Date(inputDate);
    let date, month, year;
    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
    date = date.toString().padStart(2, "0");
    month = month.toString().padStart(2, "0");
    if (delimiter) {
        return `${year}${delimiter}${month}${delimiter}${date}`;
    }
    else {
        return `${year}${month}${date}`;
    }
}
export function formatDateyyyyMM(inputDate: any, delimiter?: String) {
    inputDate = new Date(inputDate);
    let month, year;
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
    month = month.toString().padStart(2, "0");
    if (delimiter) {
        return `${year}${delimiter}${month}`;
    }
    else {
        return `${year}${month}`;
    }
}
export function formatDateyyyyMMddTHHMM(inputDate: any, delimiter?: String) {
    inputDate = new Date(inputDate);
    let date, month, year, hh, mm;
    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
    date = date.toString().padStart(2, "0");
    month = month.toString().padStart(2, "0");
    hh = inputDate.getHours().toString().padStart(2, "0");
    mm = inputDate.getMinutes().toString().padStart(2, "0");
    if (delimiter) {
        return new Date(`${year}${delimiter}${month}${delimiter}${date}T${hh}:${mm}`);
    }
    else {
        return new Date(`${year}${month}${date}T${hh}:${mm}`);
    }
}
export function formatDate(inputDate: any, delimeter?: String) {
    inputDate = new Date(inputDate);
    let date, month, year;
    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
    date = date.toString().padStart(2, "0");
    month = month.toString().padStart(2, "0");
    if (delimeter) {
        return `${date}${delimeter}${month}${delimeter}${year}`;
    }
    else {
        return `${date}${month}${year}`;
    }
}
export function getDate(inputDate: any) {
    if (!inputDate) return;

    inputDate = new Date(inputDate);
    let date;
    date = inputDate.getDate();
    //date = date.toString().padStart(2, "0");
    return date;
}
export function getMonth(inputDate: any) {
    if (!inputDate) return;

    inputDate = new Date(inputDate);
    let month;
    month = inputDate.getMonth() + 1;
    //month = month.toString().padStart(2, "0");
    return month;
}
export function getYear(inputDate: any) {
    if (!inputDate) return;

    inputDate = new Date(inputDate);
    let year;
    year = inputDate.getFullYear();
    return year;
}
export function formatDateTime(date: any, formatStr: string) {
    const inputDate = new Date(date);
    //'dd MMM yyyy HH:mm' HH → 24-hour format
    //'dd MMM yyyy hh:mm' hh → 12-hour format
    const formatted = format(inputDate, formatStr);
    return formatted;
}
export function getTimeDiffDF(startDate: Date | string, endDate: Date | string): string {
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) return '';

    const hours = differenceInHours(end, start);
    const minutes = differenceInMinutes(end, start) % 60;

    return `${hours > 0 ? `${hours}h` : ''} ${minutes > 0 ? `${minutes}m` : ''}`;
}
export function formatShortMonthYear(inputDate: any) {
    return new Date(inputDate).toLocaleDateString('en-IN', { month: "short", year: "numeric" })
}
export function formatshortDayMonthYear(date: any) {
    return date ? new Date(date).toLocaleDateString('en-IN', {
        day: "numeric",
        month: "short",
        year: "numeric",
    })
        : "";
    //22 June 2025
}
export function getSelectLabel(options: any[], value: any) {
    if (options.length > 0) {
        const selectedValues = Array.from(options)
            .filter((option: any) => option.value == value)
            .map((option: any) => option.label);
        return selectedValues || value;
    }
    else
        return value;
}
export function getYearsDDL(yearsIncrement: number, year: number = 0) {
    const currentYear = new Date().getFullYear();
    let nextYears = Array.from({ length: yearsIncrement }, (_, i) => currentYear + i)
        .map((year: number, index) => ({ label: year, value: year }))
    if (year != 0 && year < currentYear) {
        nextYears = [{ label: year, value: year }, ...nextYears];
        //nextYears.push({ label: year, value: year });
    }
    return nextYears;
}
export function getmonthsDDL(years: number, month: number = 0) {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth(); // 0-based index for months 
    let filteredMonths: any = [];
    if (currentYear == years) {
        filteredMonths = AllMonths.slice(currentMonth);
    }
    else if (currentYear < years) {
        filteredMonths = AllMonths;
    }
    if (month != 0) {
        const selectedValues = Array.from(AllMonths).filter((option: any) => option.value == month);

        if (!(Array.from(filteredMonths).filter((option: any) => option.value == month).length > 0))
            filteredMonths = [selectedValues[0], ...filteredMonths];
    }
    return filteredMonths;
}
export const encodeParam = (param: any) => {
    return btoa(param).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
export const decodeParam = (param: any) => {
    try {
        param = param.padEnd(param.length + (4 - param.length % 4) % 4, '=');
        return atob(param.replace(/-/g, '+').replace(/_/g, '/'));
    } catch (e) {
        return "";
    }
};
export const convertTextToSlugify = (str: any) => str.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '');
export const convertSlugifyToText = (str: any) => str ? str.replace(/-/g, ' ').replace(/\b\w/g, (l: any) => l.toUpperCase()) : null;

export function formatText(text: any, splitDelimeter: any, outputDelimeter: any) {
    const formattedText = text
        .split(splitDelimeter)
        .map((part: any, index: any) =>
            part.trim().charAt(0).toUpperCase() + part.trim().slice(1) // Capitalize only first letter
        )
        .join(` ${outputDelimeter} `);

    return formattedText;
}
export function capitalizeFirstLetter(text: any) {
    const formattedText = text
        ?.split(' ')
        ?.map((word: any) =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        ?.join(' ');

    return formattedText;
}
export function getShortWeekDay(year: any, month: any, date: any) {
    const tempDate = new Date(year + "-" + month + "-" + date);
    return tempDate.toLocaleString('default', { weekday: 'short' })
}
export function getDateMonthRange() {
    const nextYears = NextYearsDDL;
    const today = new Date();

    const minDate = today;

    const maxDateObj = new Date(today);
    maxDateObj.setFullYear(today.getFullYear() + nextYears);
    const maxDate = maxDateObj;

    const minMonth = new Date(today + "-01");
    const maxMonth = new Date(maxDateObj + "-01");

    return {
        minDate,
        maxDate,
        minMonth,
        maxMonth
    };
}
export const getPackageType = (packageType: any) => {
    if (packageType == "fixed")
        packageType = "group tour";
    return formatText(packageType, ' ', '');
}

export const getDiscountedPrice = (discountType: any, cost: any, discount: any) => {
    let amount = cost;
    if (amount > 0) {
        if (discountType == "fixed")
            amount = cost - discount;
        else if (discountType == "percent")
            amount = cost - (cost * discount / 100)
    }
    return amount;
}
export const scrollTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
export const getTextFromHtml = (htmlString: any) => {
    try {
        // Parse HTML string into a document
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        // Extract only the text content
        return doc.body.textContent || "";
    } catch (error) {
        console.error("Error parsing HTML:", error);
        return htmlString;
    }
}
export const buildLocationTree = (data: any): any[] => {
    if (!data) return data;

    let arrData = JSON.parse(data);
    const regionMap = new Map<number, any>()

    arrData.forEach((item: any) => {
        // Region
        if (!regionMap.has(item.regionId)) {
            regionMap.set(item.regionId, {
                id: item.regionId,
                name: item.regionName,
                countries: []
            })
        }

        const region = regionMap.get(item.regionId)!

        // Country
        let country = region.countries.find((c: any) => c.id === item.countryId)
        if (!country) {
            country = {
                id: item.countryId,
                name: item.countryName,
                states: []
            }
            region.countries.push(country)
        }

        // State
        let state = country.states.find((s: any) => s.id === item.stateId)
        if (!state) {
            state = {
                id: item.stateId,
                name: item.stateName,
                cities: []
            }
            country.states.push(state)
        }

        // City
        if (!state.cities.some((c: any) => c.id === item.cityId)) {
            state.cities.push({
                id: item.cityId,
                name: item.cityName
            })
        }
    })

    return Array.from(regionMap.values())
}
export const getDistinctCountryStateCityCounts = (tree: any[]) => {
    const countrySet = new Set<string>();
    const stateSet = new Set<string>();
    const citySet = new Set<string>();

    tree?.forEach(region => {
        region?.countries?.forEach((country: any) => {
            countrySet.add(country.name);

            country?.states?.forEach((state: any) => {
                stateSet.add(state.name);

                state?.cities?.forEach((city: any) => {
                    citySet.add(city.name);
                });
            });
        });
    });

    return {
        countryCount: countrySet.size,
        stateCount: stateSet.size,
        cityCount: citySet.size
    };
};
//#region addDays
export const addDays = (date: any, days: any) => {
    const result = new Date(date); // Clone the date to avoid mutation
    result.setDate(result.getDate() + days);
    return result;
}
//#endregion
//#region subDays
export const subDays = (date: any, days: any) => {
    const result = new Date(date); // Clone the date to avoid mutation
    result.setDate(result.getDate() - days);
    return result;
}
//#endregion

/** Clears Bootstrap/reactstrap body scroll-lock left after modal close/HMR. */
export const unlockBodyScroll = () => {
    if (typeof document === "undefined") return;

    // Only keep lock if another modal is still visibly open
    const openModals = Array.from(document.querySelectorAll(".modal.show")).filter((el) => {
        const style = window.getComputedStyle(el);
        return style.display !== "none" && style.visibility !== "hidden";
    });
    if (openModals.length > 0) return;

    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("overflow-x");
    document.body.style.removeProperty("overflow-y");
    document.body.style.removeProperty("padding-right");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    document.documentElement.classList.remove("modal-open");
    document.documentElement.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("padding-right");

    document.querySelectorAll<HTMLElement>(".sticky-top, .fixed-top, .fixed-bottom, #header").forEach((el) => {
        el.style.removeProperty("padding-right");
    });

    window.scrollTo({ left: 0 });
    document.documentElement.scrollLeft = 0;
    document.body.scrollLeft = 0;

    // Never remove backdrops synchronously — React/Bootstrap portals still own them
    // during onClosed/onExited and will throw removeChild NotFoundError.
    window.setTimeout(() => {
        if (document.querySelector(".modal.show")) return;
        document.querySelectorAll(".modal-backdrop").forEach((el) => {
            try {
                if (el.isConnected && el.parentNode) {
                    el.parentNode.removeChild(el);
                }
            } catch {
                // Ignore races with portal unmount
            }
        });
    }, 350);
};

export const normalizeNewsroomType = (type?: string | null): string =>
    type?.trim().toLowerCase() ?? "";
